/**
 * The request permission vocabulary: every permission acts on an existing request. Creating one is not
 * here — it comes before the request exists, so a role holds it through its own toggle
 * (`organisation.request_creator`), not through a set.
 */
export const REQUEST_PERMISSIONS = [
  'view',
  'edit_metadata',
  'manage_participants',
  'pause',
  'reject',
  'delete',
  'edit_submissions',
  'view_documents',
  'edit_documents',
  'manage_documents',
  'manage_assignees',
  'skip',
  'rollback',
  'manage_integrations',
  'manage_sourcing',
  'administer',
  'view_tprm',
  'edit_tprm',
  'manage_tprm',
] as const
export type RequestPermission = (typeof REQUEST_PERMISSIONS)[number]

export const requestGrantsRelation = (permission: RequestPermission): `grants_${RequestPermission}` => `grants_${permission}`
export const requestGrantedRelation = (permission: RequestPermission): `granted_${RequestPermission}` => `granted_${permission}`
export const requestCanRelation = (permission: RequestPermission): `can_${RequestPermission}` => `can_${permission}`
